import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { HospitalityService } from 'src/app/shared/services/hospitality.service';
import { NgForm,FormsModule } from '@angular/forms';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
declare  var jQuery:  any;
import * as moment from  'moment';

@Component({
  selector: 'app-matchday',
  templateUrl: './matchday.component.html',
  styleUrls: ['./matchday.component.scss']
})
export class MatchdayComponent implements OnInit {
  
  is_authenticate_user: boolean = false;
  hcontactRequest: any= {};
  hcontactError: any;
  hcontactSuccess: any;
  hospitalityList: any = "";

  constructor(
    public authService: AuthService,
    public hospitalityService: HospitalityService,
    private router: Router,
    ) { }

  ngOnInit() {
   
      this.hospitalityService.getHospitality().then((data) => {
        this.hospitalityList = data;
        console.log(this.hospitalityList);
        setTimeout(function(){
          jQuery('.popup-login').magnificPopup({
          type: 'inline',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,

          fixedContentPos: false,
          callbacks: {
            open: function() {
              
            },
            close: function() {
              //console.log("close");
            }
            // e.t.c.
          }
        });
        },1000);
      });
    
    
  }

  
  contactUs(form:NgForm, assignid: any){
   
    if (form.valid) {
      //console.log(this.checkoutRequest.email);
      this.hcontactRequest.hospitality_id = jQuery("#hospitality_id-"+assignid).val();

      let request:any = { };
      request = Object.assign({}, this.hcontactRequest);
      //console.log(request);
      this.hospitalityService.hcontactUs(request).then(
        (res) => {
          console.log(res);
          
          if(res.status==0)
          {
            this.hcontactError = res.message;
          }else{

              jQuery.magnificPopup.close();

          }
        }).catch((err) => {
          this.hcontactError = err.error.message;
        });
    }
 
  }



}
